import { useEffect, useState } from 'react'

import { env } from '@/config/env'

/**
 * Legacy `useSearchJob`: `GET /public/jobs/suggest?term=` on every term change, results are job
 * titles. Debounced here (legacy fired per keystroke) and cancelled on the next keystroke so a
 * slow early answer cannot overwrite a fast later one; under 2 characters nothing is asked —
 * the server answers nothing for that anyway.
 */
export function useJobSuggestions(term: string) {
  const [titles, setTitles] = useState<string[]>([])
  const [searching, setSearching] = useState(false)

  useEffect(() => {
    const clean = term.trim()
    if (clean.length < 2) {
      setTitles([])
      return
    }
    const controller = new AbortController()
    const timer = window.setTimeout(() => {
      setSearching(true)
      fetch(`${env.apiUrl}/public/jobs/suggest?term=${encodeURIComponent(clean)}`, { signal: controller.signal })
        .then(async (response) => (response.ok ? ((await response.json()) as { keys?: Array<{ title: string }> }) : { keys: [] }))
        .then((data) => setTitles((data.keys ?? []).map((k) => k.title)))
        .catch(() => {
          if (!controller.signal.aborted) setTitles([])
        })
        .finally(() => {
          if (!controller.signal.aborted) setSearching(false)
        })
    }, 200)
    return () => {
      window.clearTimeout(timer)
      controller.abort()
    }
  }, [term])

  return { titles, searching }
}
